function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", null, "\r\n@keyframes akrxv36gocqy6gc6to87ozl7_t { 0% { transform: translate(-75px,-20px); animation-timing-function: cubic-bezier(.4,0,.6,1); } 37.895% { transform: translate(-75.1px,-6.9px); animation-timing-function: cubic-bezier(.4,0,.6,1); } 100% { transform: translate(-75px,-20px); animation-timing-function: cubic-bezier(.4,0,.6,1); } }\r\n@keyframes b8t6gkns8a799h5t19mdx21q_t { 0% { transform: translate(13px,94px); animation-timing-function: cubic-bezier(.4,0,.6,1); } 45.386% { transform: translate(13px,97px); animation-timing-function: cubic-bezier(.4,0,.6,1); } 100% { transform: translate(13px,94px); } }\r\n@keyframes qyczqudsa6pqhare8n9iqlnj_t { 0% { transform: translate(-163.7px,113px); animation-timing-function: cubic-bezier(.4,0,.6,1); } 51.436% { transform: translate(-163.8px,120.1px); animation-timing-function: cubic-bezier(.4,0,.6,1); } 100% { transform: translate(-163.7px,113px); } }\r\n@keyframes ae442knjljmfgn4uo1q0rrb7_t { 0% { transform: translate(39px,81px); animation-timing-function: cubic-bezier(.4,0,.6,1); } 54.338% { transform: translate(38.9px,75.9px); animation-timing-function: cubic-bezier(.4,0,.6,1); } 100% { transform: translate(39px,81px); } }\r\n@keyframes s22p7xcpnp1cm2cs0tufb0p3_t { 0% { transform: translate(24px,49px); animation-timing-function: cubic-bezier(.4,0,.6,1); } 50.663% { transform: translate(24px,46px); animation-timing-function: cubic-bezier(.4,0,.6,1); } 100% { transform: translate(24px,49px); } }\r\n@keyframes ok833bj0i0xpvzh122pmxa2j_t { 0% { transform: translate(41px,-0.1px) scale(1,1); animation-timing-function: cubic-bezier(.4,0,.6,1); } 49.977% { transform: translate(40.9px,4.5px) scale(1,1); animation-timing-function: cubic-bezier(.4,0,.6,1); } 100% { transform: translate(41px,-0.1px) scale(1,1); } }\r\n@keyframes i9vj19hswypvfplumrxv7ff8_t { 0% { transform: translate(-193.6px,23.6px) scale(1,1); animation-timing-function: cubic-bezier(.4,0,.6,1); } 51.607% { transform: translate(-194.1px,12.9px) scale(1,1); animation-timing-function: cubic-bezier(.4,0,.6,1); } 100% { transform: translate(-193.6px,23.6px) scale(1,1); } }\r\n");

var _ref3 = /*#__PURE__*/React.createElement("title", null, "Pic/Popup/Death start");

var _ref4 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref5 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(75,15)"
}, /*#__PURE__*/React.createElement("g", {
  stroke: "#92bfff",
  strokeWidth: 4,
  transform: "translate(6.3,13.5)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 31.5h128.2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 93.5h127.2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24 .5h81.2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.4 123.5h77.3"
})), /*#__PURE__*/React.createElement("path", {
  d: "M57.6 45c-0.1 .7-0.1 1.4-0.2 2.1c-0.9 8.7-1.4 18.3-1.4 28.3m1.8 32c1.5 12.3 3.8 22.8 6.6 30.3m27.8-30c1.1-9.8 1.8-20.7 1.8-32.3m-1.6-30.5c-1.4-11.9-3.5-22.2-6.1-29.9",
  stroke: "#92bfff",
  strokeWidth: 4
}), /*#__PURE__*/React.createElement("path", {
  d: "M26 75c0 11.4 1.7 22.2 4.6 31.9m44.4 43.1c10.1 0 19.5-4.7 27.3-12.7c7.3-7.5 13.2-17.9 17-30.1m4.7-32.2c0-10.7-1.5-20.8-4.1-30m-15.7-30.2c-8.1-9.3-18.2-14.8-29.2-14.8c-10.5 0-20.3 5.1-28.3 13.7c-7.3 8-13.2 19-16.8 31.8",
  stroke: "#92bfff",
  strokeWidth: 4
}), /*#__PURE__*/React.createElement("path", {
  d: "M138 57h9.8c1.4 5.8 2.2 11.8 2.2 18c0 6.6-0.8 12.9-2.4 19h-9.9c-7.8 32.2-35.2 56-67.7 56c-31.1 0-57.4-21.7-66.5-51.7c12.6 9.3 28.2 14.7 45 14.7c42.2 0 76.5-34.3 76.5-76.5c0-2.9-0.2-5.7-0.5-8.5c6.3 8.3 11 18.2 13.5 29Z",
  fillOpacity: 0.4,
  fill: "#5c8df6",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(71,7) scale(-1,1)"
}, /*#__PURE__*/React.createElement("ellipse", {
  stroke: "#5c8df6",
  strokeWidth: 4,
  fill: "#92bfff",
  strokeLinejoin: "round",
  rx: 22.5,
  ry: 14.5,
  transform: "translate(27.5,26.5) rotate(40)"
}), /*#__PURE__*/React.createElement("ellipse", {
  stroke: "#5c8df6",
  strokeWidth: 4,
  fill: "#fff",
  strokeLinejoin: "round",
  rx: 15,
  ry: 10.5,
  transform: "translate(25,29.5) rotate(40)"
}), /*#__PURE__*/React.createElement("ellipse", {
  fill: "#5c8df6",
  rx: 9.5,
  ry: 6,
  transform: "translate(22.5,33) rotate(40)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M75 0c-41.4 0-75 33.6-75 75c0 41.4 33.6 75 75 75",
  stroke: "#5c8df6",
  strokeWidth: 4,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M70 0c32.9 0 60.4 24.3 68 57h9.8c1.4 5.8 2.2 11.8 2.2 18c0 6.6-0.8 12.9-2.4 19h-9.9c-7.8 32.2-35.2 56-67.7 56c-38.7 0-70-33.6-70-75c0-41.4 31.3-75 70-75Z",
  stroke: "#5c8df6",
  strokeWidth: 4,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1 73c3.8 .5 16.9 1.8 39.3 2c33.5 .2 38.3 .3 69.1 0c20.6-0.2 33.9-1.5 40-2",
  stroke: "#5c8df6",
  strokeWidth: 4
}), /*#__PURE__*/React.createElement("rect", {
  x: 28,
  y: 99,
  fill: "#92bfff",
  width: 16,
  height: 8,
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  x: 104,
  y: 44,
  fill: "#92bfff",
  width: 16,
  height: 8,
  rx: 2
}));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  stroke: "#5c8df6",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4,
  transform: "translate(150,33.5)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M38 .5h12",
  strokeDasharray: "12 12"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34 8.5h23",
  strokeDasharray: "23 23"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(39,16)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 .5h3",
  strokeDasharray: "3 3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11 .5h23",
  strokeDasharray: "23 23"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(65,47)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 .5h13"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20 .5h.5"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(60,65)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 .5h5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 .5h13"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(40,83)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 .5h3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11 .5h23"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(44,31)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 .5h14",
  strokeDasharray: "14 14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23 .5h2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31 .5h.5"
})), /*#__PURE__*/React.createElement("path", {
  d: "M44 99.5h23"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(40,107)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 .5h13"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20 .5h.5"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(18,115)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1 .5h.5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10 .5h30"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47 .5h4"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(5,123)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1 .5h.5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8 .5h23"
})), /*#__PURE__*/React.createElement("path", {
  d: "M0 131.5h43"
}));

var SvgDeathStar = function SvgDeathStar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "300px",
    height: "180px",
    viewBox: "0 0 300 180",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4, /*#__PURE__*/React.createElement("g", {
    transform: "translate(70.1,10.2)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(97,70) translate(-172,-90)",
    style: {
      animation: "4.75s linear infinite both akrxv36gocqy6gc6to87ozl7_t"
    }
  }, _ref5, _ref6), /*#__PURE__*/React.createElement("g", {
    stroke: "#5c8df6",
    strokeLinejoin: "round",
    strokeWidth: 4,
    transform: "translate(153,22)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 4,
    ry: 4,
    fill: "none",
    transform: "translate(13,94)",
    style: {
      animation: "1.98s linear infinite both b8t6gkns8a799h5t19mdx21q_t"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 2,
    ry: 2,
    fill: "none",
    transform: "translate(-163.7,113)",
    style: {
      animation: "2.33s linear infinite both qyczqudsa6pqhare8n9iqlnj_t"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 2,
    ry: 2,
    fill: "none",
    transform: "translate(39,81)",
    style: {
      animation: "1.53s linear .02s infinite both ae442knjljmfgn4uo1q0rrb7_t"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 3,
    ry: 3,
    fill: "none",
    transform: "translate(24,49)",
    style: {
      animation: "1.28s linear infinite both s22p7xcpnp1cm2cs0tufb0p3_t"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 4,
    ry: 4,
    fill: "none",
    transform: "translate(41,-0.1) scale(.978,.978)",
    style: {
      animation: "2.17s linear infinite both ok833bj0i0xpvzh122pmxa2j_t"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M4 0c0 2.2-1.8 4-4 4c-2.2 0-4-1.8-4-4c0-2.2 1.8-4 4-4c2.2 0 4 1.8 4 4Z",
    transform: "translate(-193.6,23.6) scale(.978,.978)",
    style: {
      animation: "2.58s linear infinite both i9vj19hswypvfplumrxv7ff8_t"
    }
  }))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDeathStar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/death-star.a711613d.svg";
export { ForwardRef as ReactComponent };